var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:{
    'btn btn-md':!_vm.is(_vm.circle),
    'btn-primary':_vm.is(_vm.primary),
    'btn-secondary': _vm.is(_vm.secondary),
    'btn-success': _vm.is(_vm.success),
    'btn-danger': _vm.is(_vm.danger),
    'btn-info': _vm.is(_vm.info),
    'btn-warning': _vm.is(_vm.warning),
    'btn-simple': _vm.is(_vm.simple),
    'btn-default': !_vm.is(_vm.primary) && !_vm.is(_vm.secondary) && !_vm.is(_vm.success) && !_vm.is(_vm.danger) && !_vm.is(_vm.info) && !_vm.is(_vm.warning) && !_vm.is(_vm.simple),
    'btn-lg': _vm.is(_vm.lg),
    'btn-md': _vm.is(_vm.md),
    'btn-sm': _vm.is(_vm.sm),
    'btn-xs': _vm.is(_vm.xs),

    'circle-button':_vm.is(_vm.circle),

    'btn-block': _vm.is(_vm.block),

    'disabled': _vm.isLoading() || _vm.disabled ,

    'scalable-btn': _vm.isScalable(_vm.scale),

    'button-position-relative': _vm.checkIfHasNotificationBadge,
  },style:(_vm.width ? `width: ${_vm.width}` : ''),attrs:{"disabled":_vm.isLoading() || _vm.disabled}},[(_vm.icon && !_vm.isLoading())?_c('span',[_c('pb-icon',{staticClass:"fa-fw",style:(_vm.iconSize ? `font-size: ${_vm.iconSize}px !important` : ''),attrs:{"icon":_vm.icon}})],1):_vm._e(),_vm._v(" "),(_vm.img && !_vm.isLoading())?_c('span',[_c('img',{style:(_vm.iconSize ? `width: ${_vm.iconSize}px !important` : ''),attrs:{"src":_vm.img}})]):_vm._e(),_vm._v(" "),(!_vm.isLoading())?_vm._t("default"):_c('div',[_c('pb-icon',{staticClass:"fas fa-sync-alt fa-spin fa-fw"}),_vm._v(" AGUARDE!")],1),_vm._v(" "),(_vm.suffixIcon && !_vm.isLoading())?_c('span',[_c('pb-icon',{staticClass:"fa-fw",attrs:{"icon":_vm.suffixIcon}})],1):_vm._e(),_vm._v(" "),(_vm.checkIfHasNotificationBadge)?_c('abbr',{staticClass:"button-notification-badge",class:{
      'button-notification-badge-top-left': _vm.notificationBadgePosition === 'top-left',
      'button-notification-badge-bottom-left': _vm.notificationBadgePosition === 'bottom-left',
      'button-notification-badge-bottom-right': _vm.notificationBadgePosition === 'bottom-right',
    },style:({ 'background-color': _vm.notificationBadgeColor })},[_vm._v("\n    "+_vm._s(_vm.notificationBadgeValue)+"\n  ")]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }